import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { TextInput } from 'react-native-paper';
import { ValidatedInput } from '.';
export const PasswordInput = forwardRef((props, ref) => {
    const [secureTextEntry, setSecureTextEntry] = useState(true);
    return (_jsx(ValidatedInput, { ref: ref, ...props, importantForAutofill: 'no', autoCorrect: false, autoComplete: 'off', autoCapitalize: 'none', spellCheck: false, textContentType: 'password', dataDetectorTypes: 'none', secureTextEntry: secureTextEntry, keyboardType: !secureTextEntry ? 'visible-password' : undefined, right: _jsx(TextInput.Icon, { icon: secureTextEntry ? 'eye-off' : 'eye', size: props.iconSize, onPress: () => setSecureTextEntry(!secureTextEntry) }) }));
});
